import { makeAutoObservable } from 'mobx';
import type { UserType } from '../types/user.type';

export class UserStore {
  private _user: UserType | undefined = undefined;
  private _auth: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  public get auth(): boolean {
    return this._auth;
  }

  public setAuth(auth: boolean) {
    this._auth = auth;
  }

  public get user(): UserType | undefined {
    return this._user;
  }

  public set(user: UserType): UserType {
    this._user = user;
    return this._user;
  }

  public delete(): void {
    this._user = undefined;
  }

  public update(updates: Partial<UserType>): UserType | undefined {
    if (this._user) {
      this._user = { ...this._user, ...updates };
    }
    return this._user;
  }
}

export const userStore = new UserStore();
